import { car } from './../../models/plan/car';
import { Resultlist } from './../../models/plan/orderItems';
import { ZaikoItems, ResultlistZaiko } from './../../models/plan/zaikoItems';
import { Subscription, Subject, Observable } from 'rxjs/Rx';
import { PlanService } from './../../services/plan.service';
import { PlanMainService } from './../service/plan-main.service';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  Input,
  ViewChild
} from '@angular/core';
import { Zaiko } from '../../models/plan/zaiko';
import { PlanStock } from '../../models/plan/planstock';
import { combineLatest } from 'rxjs/operators';
import { Recycle } from '../../models/plan/recycle';
import { UtilService } from '../../services/util.service';
import { DataService } from '../../services/data.service';
export interface ZaikoShaten {
  shatenCd?: string;
  shatenNm?: string;
}
export interface KeitooColor {
  value?: string;
  text?: string;
}
export interface Sharyou {
  kbn?: string;
  text?: string;
}
export interface Hanbai {
  kbn?: string;
  text1?: string;
  text2?: string;
  text3?: string;
}
export interface PlateAreas {
  plateAreaCd?: string;
  plateAreaNm?: string;
}
export interface Plate {
  kbn?: string;
  text?: string;
}
@Component({
  selector: 'app-car-search',
  templateUrl: './car-search.component.html',
  styleUrls: ['./car-search.component.css']
})
export class CarSearchComponent implements OnInit, OnDestroy {
  showDetail: boolean;
  @Output('close') close = new EventEmitter<any>();
  showEquipment: boolean;
  @Output() onCarsearchmaptax = new EventEmitter<any>();
  @Output() onRecycle = new EventEmitter<any>();
  @Input() searchKeyword: string;
  @ViewChild('kanriNo') kanriNoEle;
  @Output() onUsedSearchAndView = new EventEmitter<any>();
  @Input() sharyouKbn: number = 2;
  public display = false;
  public makerData: any = [];
  public makerIndexForClear: any;
  public displayModel = false;
  public makerdisplay = false;
  /////////////////////
  public modelData: any = [];
  public modeldisplay = false;
  public modelIndexForClear: any;
  ///////////////////////////
  public gradesDispaly = false;
  public displayshaten = false;
  public displaykeitooColor = false;
  public zaikoShatenlist: ZaikoShaten[] = [];
  public keitooColorlist: KeitooColor[] = [];
  public zaikoItemslist: ResultlistZaiko[] = [];
  public selectedRow: any;
  public selectlist: ResultlistZaiko = null;
  public carobj: car = {};
  public date0: Date;
  public zaiko: Zaiko = {};
  public selectshayou: Sharyou;
  public dataSharyou: Sharyou[] = [];
  public selectHanbai: Hanbai;
  public dataHanbai: Hanbai[] = [];
  public selectPlateAreas: PlateAreas;
  public dataPlateAreas: PlateAreas[] = [];
  public selectPlate: Plate;
  public dataPlate: Plate[] = [];
  public datakyotens: any;
  public datanyuuko: any;
  public displaynyukoBunrul: boolean = false;
  public displaykyoten: boolean = false;
  public ngUnsubscribe = new Subject();
  public nRetryGetShaten = 5;

  constructor(
    private _planService: PlanMainService,
    private planService: PlanService,
    private _util: UtilService,
    private _data: DataService
  ) { }
  ngOnInit() {
    this.date0 = new Date();
    this.onstatic();
    this.setZaikoShaten();
    this.ongetLoadAPI();
    if (this.searchKeyword != null && this.searchKeyword != '') {
      this.zaiko.shadaiNo = this.searchKeyword;
      this.onsearch();
    }
  }
  ngAfterViewInit() {
    // this._planInternalService.getCarInfo()
    //   .takeUntil(this.ngUnsubscribe)
    //   .subscribe(cardata => {
    //     if (cardata) {
    //       this.sharyouKbn = cardata.sharyouKbn;
    //     }
    //   });
  }
  onClose() {
    this.close.emit();
  }
  closeFilter() {
    this.showEquipment = false;
    this.showDetail = false;
  }
  onShowDialog(popup: any) {
    if (popup == 1) {
      this.showEquipment = true;
    } else {
      this.showDetail = true;
    }
  }
  onShowdialogMaker() {
    this.display = true;
    this.makerdisplay = true;
    if (this.makerData.length == 0) {
      this.planService
        .getMakersDataCar()
        .takeUntil(this.ngUnsubscribe)
        .subscribe(res => {
          this.makerData = [];
          this.makerData.push({
            makerCd: '00000',
            makerNm: '未選択',
            stat: false
          });
          if (res) {
            res.forEach((val, i) => {
              this.makerData.push({
                makerCd: val.makerCd,
                makerNm: val.makerNm,
                stat: false
              });
            });
          }
        });
    } else {
      this.makerData[0].stat = false;
    }
  }
  showDialogModel() {
    this.display = true;
    this.modeldisplay = true;
    this.makerdisplay = false;
    if (this.modelData.length === 0) {
      this.planService
        .getModelsDataCar(this.zaiko.makerCd)
        .takeUntil(this.ngUnsubscribe)
        .subscribe(res => {
          if (res) {
            this.modelData.push({
              modelNm: '未選択',
              modelCd: '00000',
              stat: false
            });
            res.forEach((val, i) => {
              this.modelData.push({
                modelNm: val.modelNm,
                modelCd: val.modelCd,
                stat: false
              });
            });
          } else {
            this.modelData = res;
          }
        });
    } else {
      this.modelData[0].stat = false;
    }
  }

  filterMakerList(index: any) {
    this.planService
      .getMakersDataCar(index)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(res => {
        if (res) {
          this.makerData = [];
          this.makerData.push({
            makerCd: '00000',
            makerNm: '未選択',
            stat: false
          });
          res.forEach((val, i) => {
            this.makerData.push({
              makerCd: val.makerCd,
              makerNm: val.makerNm,
              stat: false
            });
          });
        } else {
          this.makerData = null;
        }
      });
  }
  filterModelList(index: any) {
    this.planService
      .getModelsDataCar(this.zaiko.makerCd, index)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(res => {
        if (res) {
          this.modelData = [];
          this.modelData.push({
            modelNm: '未選択',
            modelCd: '00000',
            stat: false
          });
          res.forEach((val, i) => {
            this.modelData.push({
              modelNm: val.modelNm,
              modelCd: val.modelCd,
              stat: false
            });
          });
        } else {
          this.modelData = null;
        }
      });
  }

  onTimeoutCloseDialog(event: any) {
    setTimeout(() => {
      this.oncloseDialog(event);
      this.display = false;
    }, 500);
  }

  makerSelected(maker: any, index: number, event: any) {
    let unselect = false;
    if (maker.makerCd == '00000') {
      unselect = true;
      this.makerData[index].stat = true;
      this.makerData.forEach((val, i) => {
        if (maker.makerCd !== val.makerCd) {
          this.makerData[i].stat = false;
        }
      });
    }
    if (this.makerData[index].stat || unselect) {
      if (!unselect) {
        this.makerData[index].stat = false;
      }
      this.zaiko.makerNm = null;
      this.zaiko.makerCd = null;
      this.zaiko.modelCd = null;
      this.zaiko.modelNm = null;
    } else {
      for (let i = 0; i < this.makerData.length; i++) {
        this.makerData[i].stat = false;
      }
      this.makerData[index].stat = true;
      this.zaiko.makerCd = maker.makerCd;
      this.zaiko.makerNm = maker.makerNm;
      this.zaiko.modelCd = null;
      this.zaiko.modelNm = null;
    }
    this.onTimeoutCloseDialog(event);
  }

  modelSelected(model: any, index: number, event: any) {
    let unselect = false;
    if (model.modelCd == '00000') {
      unselect = true;
      this.modelData[index].stat = true;
      this.modelData.forEach((val, i) => {
        if (model.modelCd !== val.modelCd) {
          this.modelData[i].stat = false;
        }
      });
      this.onTimeoutCloseDialog(event);
    }
    if (this.modelData[index].stat || unselect) {
      if (!unselect) {
        this.modelData[index].stat = false;
      }
      this.zaiko.modelNm = null;
      this.zaiko.modelCd = null;
      this.onTimeoutCloseDialog(event);
    } else {
      for (let i = 0; i < this.modelData.length; i++) {
        this.modelData[i].stat = false;
      }
      this.modelData[index].stat = true;
      this.zaiko.modelCd = model.modelCd;
      this.zaiko.modelNm = model.modelNm;
      this.zaiko.gradeNm = null;
    }
    this.onTimeoutCloseDialog(event);
  }

  oncloseDialog(event: any) {
    this.display = false;
    this.makerdisplay = false;
    this.modeldisplay = false;
    this.gradesDispaly = false;
    this.displaykyoten = false;
  }
  onshowshaten() {
    this.displayshaten = true;
    this._planService
      .getzaikoShaten()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((response: ZaikoShaten[]) => {
        this.zaikoShatenlist = [];
        if (response != null) {
          this.zaikoShatenlist = response;
        }
      });
  }
  onRowSelect(event: any) {
    setTimeout(() => {
      this.zaiko.shatenCd = event.data.shatenCd;
      this.zaiko.shatenNm = event.data.shatenNm;
      this.displayshaten = false;
    }, 500);
  }
  onshowColor() {
    this.displaykeitooColor = true;
    this.planService
      .getKeitooColors()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((res: KeitooColor[]) => {
        this.keitooColorlist = [];
        if (res) {
          this.keitooColorlist = res;
        }
        this.keitooColorlist.splice(0, 0, { 'value': '', 'text': '【選択なし】' });
      });
  }
  onRowSelectColor(event: any) {
    setTimeout(() => {
      if (event.data.value == '') {
        this.zaiko.keitooColor = '';
        this.zaiko.colorname = '';
      } else {
        this.zaiko.colorname = event.data.text;
        this.zaiko.keitooColor = event.data.value;
      }
      this.displaykeitooColor = false;
    }, 500);
  }
  oncloseshaten(event: any) {
    this.displayshaten = false;
  }
  oncloseColor(event: any) {
    this.displaykeitooColor = false;
  }
  onsearch() {
    // console.log(this.zaiko);
    this._planService
      .getZaikoItems(this.zaiko)
      .takeUntil(this.ngUnsubscribe)
      .subscribe((response: ZaikoItems) => {
        this.zaikoItemslist = [];
        this.selectlist = null;
        if (response != null || response !== undefined) {
          this.zaikoItemslist = response.result;
          this.selectedRow = null;
          this.selectlist = null;
        } else {
          this.selectedRow = null;
          this.selectlist = null;
        }
      });
  }
  setClickedRow(data: ResultlistZaiko, index: any) {
    if (this.selectedRow && this.selectedRow == index) {
      this.selectedRow = null;
      this.selectlist = null;
    } else {
      this.selectedRow = index;
      this.selectlist = data;
    }
  }
  onDbclickTable(data: ResultlistZaiko) {
    /**
     * move to planone method
    this.planService
      .ongetStockDetail(data.shatenCd, data.kanriNo)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(stock => {
        if (stock) {
          this._planService.setKanriNo(stock.kanriNo.toString());
          this.onmapResultlistZaiko(stock);
        }
      });
    */
    const stock = {
      shatenCd: data.shatenCd,
      kanriNo: data.kanriNo
    };
    this.onUsedSearchAndView.emit(stock);
    this.close.emit();
    this.planService.pagecheck.next(false);
  }
  onstatic() {
    this.zaiko.makerNm = null;
    this.zaiko.modelNm = null;
    this.zaiko.shatenNm = null;
    this.zaiko.shatenCd = null;
    this.zaiko.colorname = null;
    this.zaiko.hanbaiPriceFrom = null;
    this.zaiko.hanbaiPriceTo = null;
    this.zaiko.nenshikiFrom = null;
    this.zaiko.kanriNo = null;
    this.zaiko.katashiki = null;
    this.zaiko.plateModel = null;
    this.zaiko.plateKana = null;
    this.zaiko.plateBangou = null;
    this.zaiko.shadaiNo = null;
    this.zaiko.kyotenname = null;
    this.zaiko.bunruiname = null;
    this.zaiko.shatenCd = null;

    this.planService.soubiData = [];
  }
  onconfirmZaiko() {
    if (this.selectlist) {
      // console.log(this.selectlist);
      /**
       * move to planone
      this.planService
        .ongetStockDetail(this.selectlist.shatenCd, this.selectlist.kanriNo)
        .takeUntil(this.ngUnsubscribe)
        .subscribe(stock => {
          if (stock) {
            this._planService.setKanriNo(stock.kanriNo.toString());
            this.onmapResultlistZaiko(stock);
          }
        });
      */
      const stock = {
        shatenCd: this.selectlist.shatenCd,
        kanriNo: this.selectlist.kanriNo
      };
      this.onUsedSearchAndView.emit(stock);
      this.close.emit();
      this.planService.pagecheck.next(false);
    }
  }
  // onmapResultlistZaiko(data: PlanStock) {
  //   if (data != null && data !== undefined) {
  //     // this.planService.allFlags.next({ ...flage, newCar: newCar });
  //     this.carobj.colorNm = data.colorNm;
  //     this.carobj.equipments = data.equipments;
  //     this.carobj.gradeNm = data.gradeNm;
  //     this.carobj.gradeCd = data.gradeCd;
  //     this.carobj.zaikoCd = data.zaikoCd;
  //     this.carobj.gradeNm = data.gradeNm;
  //     this.carobj.modelNm = data.modelNm;
  //     this.carobj.makerNm = data.makerNm;
  //     this.carobj.keitooColorCd = data.keitooColorCd;
  //     this.carobj.kanriNo = data.kanriNo;
  //     this.carobj.shatenCd = data.shatenCd;
  //     this.carobj.katashiki = data.katashiki;
  //     this.carobj.makerCd = data.makerCd;
  //     this.carobj.modelCd = data.modelCd;
  //     this.carobj.shadaiNo = data.shadaiNo;
  //     this.carobj.nenshiki = data.nenshiki;
  //     this.carobj.soukouKm = Number(+data.soukouKm);
  //     this.carobj.gradeKaiseiYm = data.gradeKaiseiYm;
  //     this.carobj.shiftKbn = data.shiftKbn.toString();
  //     this.carobj.shutokuzeiAutoCalcKbn = +data.shutokuzeiAutoCalcKbn;
  //     this.carobj.shutokuzeiKbn = +data.shutokuzeiKbn;
  //     this.carobj.soukouBikouKbn = +data.soukouBikouKbn;
  //     this.carobj.soukouUnitKbn = +data.soukouUnitKbn;
  //     this.carobj.shutokuzei = +data.shutokuzei;
  //     this.carobj.jidoushazeiCd = data.jidoushazeiCd;
  //     this.carobj.sharyouKbn = +data.sharyouKbn;
  //     this.carobj.shakenUmuKbn = data.shakenUmuKbn;
  //     this.carobj.shakenKigenYmd = data.shakenKigenYmd;
  //     this.carobj.shakenKigenKbn = data.shakenKigenKbn;
  //     this.carobj.ruibetsuKubunNo = data.ruibetsuKubunNo;
  //     this.carobj.juuryouzeiCd = data.juuryouzeiCd;
  //     this.carobj.jibaisekiCd = data.jibaisekiCd;
  //     this.carobj.itenKbn = data.itenKbn;
  //     this.carobj.isImportCar = +data.isImportCar;
  //     this.carobj.priceZk = +data.priceZk;
  //     this.carobj.priceZn = +data.priceZn;
  //     this.carobj.katashikiShiteiNo = data.katashikiShiteiNo;
  //     this.carobj.displacement = data.displacement;
  //     this.carobj.soukouMile = data.soukouMile;
  //     this.carobj.lastUpdatedTime = data.lastUpdatedTime;
  //     this.carobj.nebikiZk = 0;
  //     this.carobj.nebikiZn = 0;
  //     this.carobj.isHikazeiHontaiPrice = 0;
  //     // this.carobj.hanbaiKbn = data.hanbaiKbn;
  //     // this.carobj.isHikazeiHontaiPrice = 0;
  //     this._planService.setstockdetail(data);
  //     this.onsetFlags(data);
  //     this.planService.setPriceZk(this.carobj.priceZk);
  //     this.planService.setPriceZn(this.carobj.priceZn);
  //     // this._planService.setDatauseCar(this.carobj);
  //     this.ongetJuuryouzeiDeatil(data);
  //     let recycle = <Recycle>{};
  //     recycle.airBag = data.recycle.airbag;
  //     recycle.freonKind = data.recycle.freon;
  //     recycle.ticketNo = data.recycle.ticketNo;
  //     if (data.recycle.yotakuKbn > -1) {
  //       recycle.yotakuKbn = data.recycle.yotakuKbn;
  //     }
  //     recycle.jyouhouKanri = data.recycle.infoManagement;
  //     recycle.shredderDust = data.recycle.shredderDust;
  //     recycle.shikinKanri = data.recycle.fundManagementZk;
  //     this._planService.addRecycledata(recycle);
  //     this.onRecycle.emit(recycle);
  //     this.planService.onresetloan();
  //   }
  // }
  onequipmentsData(event) {
    this.zaiko.equipment = event;
  }

  ongetLoadAPI() {
    this.planService
      .getSharyouKubun()
      .takeUntil(this.ngUnsubscribe)
      .subscribe(data => {
        if (data && data.length !== 0) {
          console.log(this.sharyouKbn)
          this.dataSharyou = data;
          if (this.sharyouKbn == 1) {
            this.dataSharyou = this.dataSharyou.filter(item => item.kbn === '1');
          } else {
            this.dataSharyou = this.dataSharyou.filter(item => item.kbn !== '1');
          }
        }
      });
    this.planService
      .getHanbai()
      .takeUntil(this.ngUnsubscribe)
      .subscribe(hanbai => {
        if (hanbai && hanbai.length !== 0) {
          this.dataHanbai = hanbai;
        }
      });
    this.planService
      .getPlateAreas()
      .takeUntil(this.ngUnsubscribe)
      .subscribe(plateAres => {
        if (plateAres && plateAres.length !== 0) {
          this.dataPlateAreas = plateAres;
        }
        this.dataPlateAreas.splice(0, 0, { 'plateAreaCd': '', 'plateAreaNm': '' });
      });
    this.planService
      .getPlate()
      .takeUntil(this.ngUnsubscribe)
      .subscribe(plate => {
        if (plate && plate.length !== 0) {
          this.dataPlate = plate;
        }
      });
    this._planService
      .getkyotens()
      .takeUntil(this.ngUnsubscribe)
      .subscribe(data => {
        if (data && data.length !== 0) {
          this.datakyotens = data;
        }
        if (data == null) {
          this.datakyotens = [];
        }
        this.datakyotens.splice(0, 0, { 'kyotenCd': '', 'kyotenNm': '【選択なし】' });
      });
    this.planService
      .getnyuukoBunrui()
      .takeUntil(this.ngUnsubscribe)
      .subscribe(nyuuko => {
        if (nyuuko && nyuuko.length !== 0) {
          this.datanyuuko = nyuuko;
        }
        if (this.datanyuuko == null) {
          this.datanyuuko = [];
        }
        this.datanyuuko.splice(0, 0, { 'bunruiCd': '', 'bunruiNm': '【選択なし】' });
      });
    // getPlateAreas
  }
  onchangshayou(event) {
    if (this.selectshayou) {
      this.zaiko.sharyouKbn = +this.selectshayou.kbn;
    } else {
      this.zaiko.sharyouKbn = 0;
    }
  }
  onchangePlateAreas() {
    if (this.selectPlateAreas) {
      this.zaiko.plateArea = this.selectPlateAreas.plateAreaCd;
    }
  }
  onnenshikiTo(event) {
    if (event) {
      this.zaiko.nenshikiTo = this._planService.setStringdate(
        'YYYYMM',
        event.value
      );
    } else {
      this.zaiko.nenshikiTo = null;
    }
  }
  onnenshikiFrom(event) {
    if (event) {
      this.zaiko.nenshikiFrom = this._planService.setStringdate(
        'YYYYMM',
        event.value
      );
    } else {
      this.zaiko.nenshikiFrom = null;
    }
  }
  onchangeHanbai() {
    // if(this.selectHanbai){
    //   this.zaiko.ha
    // }
  }
  onchangePlate() {
    if (this.selectPlate) {
      this.zaiko.plateKbn = +this.selectPlate.kbn;
    }
  }
  onRowSelectzaikoKyoten(event) { }
  onclosenyukoBunrul() {
    this.displaynyukoBunrul = false;
  }
  onPlate() {
    if (this.selectPlate) {
      this.zaiko.plateKbn = +this.selectPlate.kbn;
    }
  }
  onRowSelectKyoten(event) {
    setTimeout(() => {
      if (event.data.kyotenCd == '') {
        this.zaiko.zaikoKyoten = '';
        this.zaiko.kyotenname = '';
      } else {
        this.zaiko.zaikoKyoten = event.data.kyotenCd;
        this.zaiko.kyotenname = event.data.kyotenNm;
      }
      this.displaykyoten = false;
    }, 200);
  }
  onRownyuuko(event) {
    setTimeout(() => {
      if (event) {
        if (event.data.bunruiCd == '') {
          this.zaiko.nyukoBunrui = '';
          this.zaiko.bunruiname = '';
        } else {
          this.zaiko.nyukoBunrui = event.data.bunruiNm;
          this.zaiko.bunruiname = event.data.bunruiNm;
        }
        this.displaynyukoBunrul = false;
      }
    }, 200);
  }
  onsetFlags(data: PlanStock) {
    const flage = this.planService.allFlags.getValue();
    let keiyon = '0';
    let newCar = '0';
    let shaken = '1';
    const shakenDate = this._planService.getDate(data.shakenKigenYmd, 'YYYYMMDD');
    const now = new Date();
    if (data.juuryouzeiCd.substring(0, 1) === 'F') {
      keiyon = '0';
    } else {
      keiyon = '1';
    }
    if (data.itenKbn == 1 && data.sharyouKbn === 1) {
      newCar = '0';
      if (shakenDate < now) {
        shaken = '0';
      }
    } else {
      newCar = '1';
      if (data.itenKbn == 1 || shakenDate < now) {
        shaken = '1';
      } else if (shakenDate > now) {
        shaken = '0';
      }
    }
    const newflag = {
      ...flage,
      newCar: newCar,
      keiyon: keiyon,
      shaken: shaken
    };
    this.planService.allFlags.next(newflag);
    this.planService.flagsUsedCar.next(newflag);
    this.planService.setShohiyou.next(newflag);
  }
  ongetJuuryouzeiDeatil(data) {
    if (data) {
      // const datetime = this._planService.setStringdate('YYYYMMDD', new Date());
      const getJidoushazeiDetail = this.planService.getJidoushazeiDetail(
        data.jidoushazeiCd
      );
      let tax = {
        shutokuzei: data.shutokuzei,
        juuryouzeiCd: data.juuryouzeiCd,
        jidoushazeiCd: data.jidoushazeiCd,
        jibaisekiCd: data.jibaisekiCd
      };
      if (data.juuryouzeiCd && data.jidoushazeiCd) {
        const getJuuryouzeiDeatil = this.planService.getJuuryouzeiDeatil(
          data.juuryouzeiCd
        );

        Observable.combineLatest(
          getJuuryouzeiDeatil,
          getJidoushazeiDetail
        ).subscribe(
          ([juuryouzei, jidoushazei]) => {
            // console.log(juuryouzei, 'juuryouzei');
            // console.log(jidoushazei, 'jidoushazei');
            tax = Object.assign(
              {
                'juuryouzeiprice': juuryouzei.weightTaxPrice,
                'jidoushazeiPrice': +jidoushazei.yearlyPayment
              }, tax);
            this.onCarsearchmaptax.emit({ ...tax });
            this.close.emit();
          },
          err => {
            this.close.emit();
          }
        );
      } else if (data.jidoushazeiCd) {
        getJidoushazeiDetail.take(1).subscribe(jidoushazei => {
          tax = Object.assign(
            { 'jidoushazeiPrice': +jidoushazei.yearlyPayment }, tax);
          this.onCarsearchmaptax.emit({ ...tax });
          this.close.emit();
        });
      } else {
        this.onCarsearchmaptax.emit({ ...tax });
        this.close.emit();
      }
    }
  }

  setZero() {
    if (this.zaiko.kanriNo) {
      this.zaiko.kanriNo = this._util.padNumber(this.zaiko.kanriNo, 10);
    }
  }

  kanriNoEnter() {
    this.kanriNoEle.nativeElement.blur();
  }

  setZaikoShaten() {
    if (this._data.staffData && this._data.staffData.shatenCd) {
        this.zaiko.shatenCd = this._data.staffData.shatenCd;
    } else if (this.nRetryGetShaten > 0) {
      this.nRetryGetShaten --;
      setTimeout(() => {
        this.setZaikoShaten();
      }, 300);
    } else {
      this.zaiko.shatenCd = null;
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/plan/car-search/car-search.component.ts